import { 
  Directive, 
  Input, 
  TemplateRef, 
  ViewContainerRef, 
  OnInit, 
  OnDestroy 
} from '@angular/core';
import { AuthService } from '@core/services';
import { Subject } from 'rxjs';

@Directive({
  selector: '[hasRole]',
  standalone: true
})
export class HasRoleDirective implements OnInit, OnDestroy {
  @Input() hasRole!: string;
  @Input() elseTemplate?: TemplateRef<HTMLElement>;
  
  private hasView = false;

  private destroy$ = new Subject<void>();

  constructor(
    private templateRef: TemplateRef<HTMLElement>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    const hasPermission = this.authService.hasRole(this.hasRole)

    if (hasPermission)
        this.updateView(hasPermission);
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateView(hasPermission: boolean): void {
    if (hasPermission && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasPermission && this.hasView) {
      if (this.elseTemplate) {
        this.viewContainer.clear();
        this.viewContainer.createEmbeddedView(this.elseTemplate);
      } else {
        this.viewContainer.clear();
      }
      this.hasView = false;
    }
  }
}